import {Area} from "./area";
import {User} from "./user";
import {Room} from "./room";

export class GlobalTemplate {
  id: number;
  publicId: string;
  version: number;
  name: string;
  areas: string[] = [];
  dateModified: string;
  createdBy: string;
  creator: User;
  sourceProject: string;
}

export enum CreatedByFilter {
  ALL = 'ALL',
  ME = 'ME'
}
